<div
	class="flex h-full flex-col md:pb-0 md:pt-0 py-2 md:mt-2 overflow-y-auto"
	data-cy="kala-market"
	[attr.aria-busy]="loading()">
	<!--
		A customer signed in without a کد بورس کالا may read the market but not trade it.
		Said once here, above whatever the list is doing, and closable for this session only.
	-->
	@if (showAccessNotice()) {
		<ui-alert
			class="mb-2 px-2"
			data-cy="market-access-notice"
			variant="red"
			iconName="blocked"
			title="عدم دسترسی انجام معاملات"
			description="مشتری گرامی برای انجام معاملات در این سامانه نیازمند دریافت کد بورس کالا می‌باشید"
			(dismissed)="onAccessNoticeDismissed()" />
	}

	@if (showLoading()) {
		<div class="flex flex-1 items-center justify-center py-10">
			<ui-loading [showMessage]="false" />
		</div>
	} @else if (error()) {
		<ui-empty-state
			class="grow items-center"
			data-cy="market-error"
			variant="error"
			iconName="alert-box"
			title="خطایی رخ داد!"
			primaryButtonLabel="تلاش مجدد"
			[showDescription]="false"
			[showButton]="true"
			(primaryClicked)="onRetry()" />
	} @else if (showEmptyState()) {
		<ui-empty-state
			class="grow items-center"
			data-cy="market-empty"
			variant="empty"
			title="نمادی برای نمایش وجود ندارد!"
			primaryButtonLabel="بارگذاری مجدد"
			[showDescription]="false"
			[showButton]="true"
			(primaryClicked)="onRetry()" />
	} @else {
		<ul class="flex list-none flex-col gap-1.5">
			@for (item of items(); track item.id) {
				<li>
					<app-symbol-card [item]="item" (pinToggled)="togglePin($event)" />
				</li>
			}
		</ul>
	}
</div>
